<template>
  <div class="wrapper-procura">
    <div class="bg-color"></div>
    <div class="container">
      <div class="row">
        <div
          class="col-12"
          style="color:white;
          margin-top: 40px;
          font-size: 20px;
          background: #888;
          padding: 5px;
          border: solid 1px white;"
        >
          <p style="font-size:24px; text-align:center;"> Procura de Veículo! </p>
          <p style="font-size:20px; text-align:center;"> {{ msg }} </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

function fromHex(hexx) {
  const hex = hexx.toString();
  let str = '';
  for (let i = 0; i < hex.length; i += 2) {
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }
  return str;
}

export default {
  name: 'Procura',
  data: () => ({
    id: null,
    operation: null,
    msg: null,
  }),
  methods: {},
  async mounted() {
    this.id = await fromHex(this.$route.params.id).split('assobens')[0];
    this.operation = this.$route.params.operation;
    if (this.operation === 'x') {
      this.msg = 'Aguarde ...';
      try {
        const ret = await axios.delete(`${url}/remove-procura`,
          { data: { id: this.id } });
        if (!ret.data.ret) {
          this.msg = 'Procura de veículo não encontrada';
        } else {
          this.msg = 'Procura por veículo excluída';
        }
      } catch (error) {
        this.msg = 'Ocorreu um erro. Por favor, tente mais tarde';
      }
    } else {
      this.msg = 'Procura por veículo mantida';
    }
  },
};
</script>

<style>
:root {
  --input-padding-x: 1.5rem;
  --input-padding-y: 0.75rem;
}

.wrapper-procura {
  /* background: #3f50f6; */
  /* background: linear-gradient(to right, #3f50f6, #694cfe); */
  background: url('../../../../assets/bg_login.png');
  min-height: 100vh;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  overflow: auto;
}

/* Fallback for Edge
-------------------------------------------------- */

@supports (-ms-ime-align: auto) {
}

/* Fallback for IE
-------------------------------------------------- */

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
}

.bg-color {
  position: fixed;
  top: 0;
  left: 0;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
}
</style>
